/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFileHeaderBlock } from './DatabaseFileHeaderBlock';
import {
    DatabaseFileHeaderBlockFromJSON,
    DatabaseFileHeaderBlockFromJSONTyped,
    DatabaseFileHeaderBlockToJSON,
} from './DatabaseFileHeaderBlock';
import type { DatabaseHeaderBlockActionType } from './DatabaseHeaderBlockActionType';
import {
    DatabaseHeaderBlockActionTypeFromJSON,
    DatabaseHeaderBlockActionTypeFromJSONTyped,
    DatabaseHeaderBlockActionTypeToJSON,
} from './DatabaseHeaderBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseTeaserImageHeaderBlock
 */
export interface DatabaseTeaserImageHeaderBlock extends DatabaseFileHeaderBlock {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTeaserImageHeaderBlock
     */
    objectFit?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTeaserImageHeaderBlock
     */
    objectPosition?: string;
}

/**
 * Check if a given object implements the DatabaseTeaserImageHeaderBlock interface.
 */
export function instanceOfDatabaseTeaserImageHeaderBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTeaserImageHeaderBlockFromJSON(json: any): DatabaseTeaserImageHeaderBlock {
    return DatabaseTeaserImageHeaderBlockFromJSONTyped(json, false);
}

export function DatabaseTeaserImageHeaderBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTeaserImageHeaderBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFileHeaderBlockFromJSONTyped(json, ignoreDiscriminator),
        'objectFit': !exists(json, 'objectFit') ? undefined : json['objectFit'],
        'objectPosition': !exists(json, 'objectPosition') ? undefined : json['objectPosition'],
    };
}

export function DatabaseTeaserImageHeaderBlockToJSON(value?: DatabaseTeaserImageHeaderBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFileHeaderBlockToJSON(value),
        'objectFit': value.objectFit,
        'objectPosition': value.objectPosition,
    };
}

